module.exports = __webpack_public_path__ + "img/img16.aa04cc14.svg";